import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showArchive' })
export class ShowArchivePipe implements PipeTransform {
  transform(customerDocument: any) {
    return !(
      customerDocument?.customerId === 15005 ||
      customerDocument?.customerId === 15007
    );
  }
}
